import * as yup from "yup";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import { useTranslation } from "react-i18next";
import FormDatePicker from "../../../../../../shared/components/datepicker/FormDatePicker";
import FormInput from "../../../../../../shared/components/input/FormInput";
import FormSelect from "../../../../../../shared/components/select/FormSelect";
import FormSwitch from "../../../../../../shared/components/switch/FormSwitch";

const CreateClientPlatformMarginForm = ({
  onSubmitHandler,
  clients,
  platforms,
}) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    beginDate: yup
      .date()
      .required(
        t("clientPlatformMargins.createForm.fields.beginDate.required"),
      ),
    endDate: yup
      .date()
      .required(t("clientPlatformMargins.createForm.fields.endDate.required")),
    clientId: yup
      .string()
      .required(t("clientPlatformMargins.createForm.fields.client.required")),
    platformId: yup
      .string()
      .required(t("clientPlatformMargins.createForm.fields.platform.required")),
    margin: yup
      .number()
      .required(t("clientPlatformMargins.createForm.fields.margin.required")),
  });

  const defaultValues = {
    beginDate: "",
    endDate: "",
    clientId: "",
    platformId: "",
    margin: 0.0,
    comments: null,
    marginInPlatform: true,
  };

  return (
    <BaseForm
      onSubmitHandler={onSubmitHandler}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
    >
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormDatePicker
            name="beginDate"
            label={t("clientPlatformMargins.createForm.fields.beginDate.label")}
            required
          />
        </div>
        <div className="w-1/2">
          <FormDatePicker
            name="endDate"
            label={t("clientPlatformMargins.createForm.fields.endDate.label")}
            required
          />
        </div>
      </div>
      <div className="flex flex-row justify-between gap-x-4 w-full">
        <div className="w-1/2">
          <FormInput
            name="comments"
            label={t("clientPlatformMargins.createForm.fields.comments.label")}
            placeholder={t(
              "clientPlatformMargins.createForm.fields.comments.placeholder",
            )}
          />
        </div>
        <div className="w-1/2">
          <FormInput
            type="number"
            name="margin"
            label={t("clientPlatformMargins.createForm.fields.margin.label")}
            required
          />
        </div>
      </div>
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormSelect
            name="clientId"
            label={t("clientPlatformMargins.createForm.fields.client.label")}
            options={clients}
            required
          />
        </div>
        <div className="w-1/2">
          <FormSelect
            name="platformId"
            label={t("clientPlatformMargins.createForm.fields.platform.label")}
            options={platforms}
            required
          />
        </div>
      </div>
      <FormSwitch
        name="marginInPlatform"
        label={t(
          "clientPlatformMargins.createForm.fields.marginInPlatform.label",
        )}
      />
    </BaseForm>
  );
};

export default CreateClientPlatformMarginForm;
